export default __webpack_public_path__ + "static/media/alipay-square.8f329d52.svg";